module.exports = __webpack_public_path__ + "img/banner_tail.b0ec92ec.png";